























import { Component, Vue } from 'vue-property-decorator';
import { BitfinexModule } from '@/store/modules/bitfinex';
import OrderbookToolbar from './OrderbookToolbar.vue';
import OrderbookContent from './OrderbookContent.vue';
import { addRank } from '@/utils/grouping';

@Component({
  name: 'BitfinexOrderbook',
  components: {
    OrderbookToolbar,
    OrderbookContent,
  },
})
export default class BitfinexOrderbook extends Vue {
  // TODO: StoreのGetterでできる
  get loaded() {
    return this.orderbook.bids.length > 0 && BitfinexModule.spread > 0 && BitfinexModule.ltp > 0;
  }
  get orderbook() {
    if (BitfinexModule.subscribed) {
      return addRank(BitfinexModule.orderbookArray);
    }
    return {
      bids: [],
      asks: [],
    };
  }
  get ltp() {
    return BitfinexModule.ltp;
  }
  get lastTickDirection() {
    return BitfinexModule.lastTickDirection;
  }
  get spread() {
    return BitfinexModule.spread;
  }
  public setFactor(factor: number) {
    BitfinexModule.setFactor(factor);
  }
}
